import React from 'react';
import PropTypes from 'prop-types';
import BentoGrid from '../ui/BentoGrid';
import SplitMetrics from '../dashboard/metrics/SplitMetrics';
import TransactionMetrics from '../dashboard/metrics/TransactionMetrics';
import ReferralMetrics from '../dashboard/metrics/ReferralMetrics';
import SharedWalletMetrics from '../dashboard/metrics/SharedWalletMetrics';
import BadgeMetrics from '../dashboard/metrics/BadgeMetrics';
import PhoneAuthMetrics from '../dashboard/metrics/PhoneAuthMetrics';
import WaitlistStats from '../waitlist/WaitlistStats';
import { useBentoSelection } from '../../hooks/useBentoSelection';
import { getBentoSizeFromCount } from '../../constants';

/**
 * Bento Overview Component for Analytics
 * Organizes analytics sections in a dynamic bento grid layout
 */
const BentoOverview = ({ period, platform, compact = false }) => {
  const { selected, toggleItem } = useBentoSelection();

  const sections = [
    { id: 'splits', label: 'Splits', cardCount: 12, content: <SplitMetrics period={period} compact={compact} /> },
    { id: 'tx', label: 'Transactions', cardCount: 9, content: <TransactionMetrics period={period} compact={compact} /> },
    { id: 'shared-wallets', label: 'Shared Wallets', cardCount: 8, content: <SharedWalletMetrics period={period} compact={compact} /> },
    { id: 'badges', label: 'Badges', cardCount: 6, content: <BadgeMetrics period={period} compact={compact} /> },
    { id: 'phone-auth', label: 'Phone Auth', cardCount: 5, content: <PhoneAuthMetrics period={period} compact={compact} /> },
    { id: 'refs', label: 'Referrals', cardCount: 6, content: <ReferralMetrics period={period} compact={compact} /> },
    { id: 'waitlist', label: 'Waitlist', cardCount: 9, content: <WaitlistStats period={period} compact={compact} /> },
  ];

  const items = sections.map(section => ({
    ...section,
    ...getBentoSizeFromCount(section.cardCount)
  }));

  return (
    <BentoGrid
      items={items}
      onToggleItem={toggleItem}
      selected={selected}
    />
  );
};

BentoOverview.propTypes = {
  period: PropTypes.string.isRequired,
  platform: PropTypes.string,
  compact: PropTypes.bool
};

BentoOverview.defaultProps = {
  platform: null,
  compact: false
};

export default BentoOverview;

